module.exports = __webpack_public_path__ + "img/6.cae92021.jpg";